export default openExternalInNewTab = () => {
    const normalizeHost = host => host.replace(/^www\./, '');

    document.addEventListener('DOMContentLoaded', () => {
        const links = document.querySelectorAll('a[href]');
        
        links.forEach(link => {
            const url = new URL(link.href, window.location.href);

            if (normalizeHost(url.hostname) === normalizeHost(window.location.hostname)) return;
            
            if (url.origin == window.location.origin) return;
            if (link.href.startsWith('mailto:')) return;
            if (link.href.startsWith('tel:')) return;

            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        });
    })
}
